import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import RestrictedPageWithCanViewQuery, {
	type RestrictedPageWithCanViewQuery$data,
	type RestrictedPageWithCanViewQuery$variables,
} from './__generated__/RestrictedPageWithCanViewQuery.graphql.ts';

export function preloadRequestViewQuery(id: string) {
	return query<RestrictedPageWithCanViewQuery$data, RestrictedPageWithCanViewQuery$variables>({
		query: RestrictedPageWithCanViewQuery,
		variables: { id },
	});
}
